import React from "react";
import { Lightbulb, Sparkles } from "lucide-react";

// One-click plain-English takeaway under a chart (computed in the browser from the loaded rows).
export function InsightStrip({ lines = [], onAskAi, testid = "insight-strip" }) {
  const empty = !lines.length;
  return (
    <div data-testid={testid}
      className="shrink-0 mt-1 flex items-start gap-2 rounded-lg border border-[color:var(--glass-border)] bg-[color:var(--surface-2)]/70 px-2.5 py-1.5 animate-in fade-in slide-in-from-bottom-1 duration-200">
      <Lightbulb className="w-3.5 h-3.5 mt-[2px] shrink-0 text-[color:var(--brand-mint)]" />
      <p data-testid="insight-text" className={`text-[11px] leading-relaxed ${empty ? "text-[color:var(--ink-3)] italic" : "text-[color:var(--ink-2)]"}`}>
        {empty ? "Not enough data in this view for a takeaway yet." : lines.join(" ")}
        {onAskAi && (
          <button data-testid="insight-ask-ai" onClick={onAskAi}
            className="ml-1.5 inline-flex items-center gap-1 align-baseline text-[color:var(--brand-ocean)] hover:underline">
            <Sparkles className="w-3 h-3" />Ask AI for more
          </button>
        )}
      </p>
    </div>
  );
}

export function InsightToggle({ on, onToggle, right = "1.75rem" }) {
  return (
    <button data-testid="insight-toggle-btn" onClick={onToggle} style={{ right }}
      title={on ? "Hide the insight line" : "Show a plain-English takeaway"}
      aria-pressed={on}
      className={`absolute top-0.5 z-10 w-6 h-6 rounded-full flex items-center justify-center transition-all hover:bg-[color:rgba(43,78,255,0.12)] ${on ? "text-[color:var(--brand-ocean)] opacity-100" : "text-[color:var(--ink-3)] opacity-40 hover:opacity-100"}`}>
      <Lightbulb className="w-3.5 h-3.5" />
    </button>
  );
}
